import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../../redux/services/Imports';
import { AnchorLink, AnchorSection } from 'react-anchor-navigation';
import './PageDeliveryCur.scss';
import './PageDeliveryCur-media.scss';

import Content from '../../../components/Content/Content';
import Button from '../../../components/Button/Button';
import Title from '../../../components/Title/Title';
import SliderLogos from '../../../components/SliderLogos/SliderLogos';
import { MetaTags } from '../../../services/content/Constants';
import Steps from '../../../components/Steps/Steps';
import { DescriptionDeliveryCur, ListQuestions, StepsList } from './content';
import List from '../../../components/List/List';
import {
  CategoryList1,
  CategoryList2,
  ListDocs,
} from '../../PageReturnDocuments/constants';
import BlockCarousel from '../../../components/BlockCarousel/BlockCarousel';
import { Props } from '../interfaces';
import DocsList from '../../../components/DocsList/DocsList';
import DescriptionBlock from '../../../components/DescriptionBlock/DescriptionBlock';
import FormContactsNew from '../../../components/FormContactsNew/FormContactsNew';
import { EnumUrlsPages } from '../../../services/Enum';
import BreadcrumbsCustom from '../../../components/Breadcrumbs/BreadcrumbsCustom';
import LogosPartners from '../../../components/LogosPartners/LogosPartners';
import { SchemaJsonQuestion } from '../../../components/Accordion/Functions';
import {Faq} from "../../../components/Faq/Faq";
import BlockTextCards from "../../../components/BlockTextCards/BlockTextCards";
import BlockIconCards from "../../../components/BlockIconCards/BlockIconCards";

const PageDeliveryCur = ({ widthWindow, offsetContent, advantagesSlider, advantagesSliderTitle, advantagesSliderNoFade, pageContent }: Props) => {
  const stylesBlock = {
    transform: `translateX(-${offsetContent}px) translateY(-${
      widthWindow > 1439 ? '124px' : widthWindow > 720 ? `${124 / 14.4}vw` : '106px'
    })`,
  };

  const title = 'Курьерская доставка для интернет-магазинов по Москве и Московской области';

  return (
    <div className="page-delivery-cur">
      <SchemaJsonQuestion questions={ListQuestions}/>

      <Content
        noLazy
        bgInto={<div className="page-delivery-cur__bg" style={stylesBlock}></div>}
        padding={{paddingMain: {top: 0, bottom: 80}, paddingMob: {top: 0, bottom: 44}}}
        block={
          <>
            <BreadcrumbsCustom title={title}/>

            <Title
              h1
              gradient
              title={title}
              text="Курьерская доставка для интернет-магазинов по Москве и Московской области на следующий день.
              Доставляйте заказы своим покупателям в столице и Подмосковье качественно и надежно."
            />

            <AnchorLink href={`${EnumUrlsPages.deliveryMsk}#form`} activeClassName="selected">
              <Button text="Стать клиентом"/>
            </AnchorLink>
          </>
        }
      />

      <Content
        heightLazy={widthWindow > 720 ? 684 : null}
        padding={{paddingMain: {top: 160, bottom: 80}, paddingMob: {top: 80, bottom: 40}}}
        block={
          <>
            <Title center title="Наши клиенты" marginBottom={40}/>
            <SliderLogos padding="0"/>
          </>
        }
      />

      <Content
        heightLazy={widthWindow > 720 ? 692 : null}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <Steps title="Простое подключение интернет-магазина к службе доставки Dalli" list={StepsList}/>
        }
      />

      {pageContent.partners?.visible && <Content
        heightLazy={widthWindow > 720 ? 422 : null}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <>
            <Title center title={pageContent.partners.title} marginBottom={40}/>
            <LogosPartners list={pageContent.partners.items}/>
          </>
        }
      />}

      <Content
        heightLazy={widthWindow > 720 ? 672 : null}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <>
            <Title center title="Курьерская доставка для большинства категорий интернет-магазинов"/>
            <div className="page-return-documents__grid-2">
              <List list={CategoryList1} check/>
              <List list={CategoryList2} check/>
            </div>
          </>
        }
      />

      <Content
        width={widthWindow > 1439 ? '1440px' : '100vw'}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={<BlockCarousel title={advantagesSliderTitle} list={advantagesSlider} noFade={advantagesSliderNoFade}/>}
      />

      <Content
        heightLazy={widthWindow > 720 ? 488 : null}
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <>
            <Title center title="Документы"/>
            <DocsList list={ListDocs}/>
          </>
        }
      />

      <Content
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <Faq
            className={"page-return-documents__quests"}
            title="Часто задаваемые вопросы"
            items={pageContent.faq?.items || []}
            expanded={pageContent.faq?.expanded || true}
          />
        }
      />

      <Content
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <DescriptionBlock
            open
            title="Курьерская служба доставки для интернет-магазинов в Москве и Московской области"
            text={DescriptionDeliveryCur}
          />
        }
      />

      <BlockTextCards heightLazy={widthWindow > 720 ? 752 : null}/>

      <BlockIconCards heightLazy={widthWindow > 720 ? 920 : null}/>

      <AnchorSection id="form">
        <Content
          heightLazy={widthWindow > 720 ? 508 : null}
          padding={{paddingMain: {top: 80, bottom: 0}, paddingMob: {top: 40, bottom: 0}}}
          block={
            <FormContactsNew
              title="Получите коммерческое предложение"
              subTitle="на сервис доставки для ваших покупателей"
              buttonText="Отправить"
              eventMetrika="form_kp_msk"
              sendAmoCRM
            />
          }
        />
      </AnchorSection>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageDeliveryCur));
